
















import { Vue, Component } from 'nuxt-property-decorator'
import Loading from '~/components/setion/k-section-state/section-loading.vue'

@Component({
  components: {
    Loading
  }
})

export default class SearchSkeleton extends Vue {
}
